// extracted by mini-css-extract-plugin
export default {"productCard":"ProductCard_productCard__rp8el","accordionContainer":"ProductCard_accordionContainer__0gUbk","accordionContent":"ProductCard_accordionContent__Ev9Hy"};